import React from "react";
import { TableHeaderColumnType } from "app/components/Table/types";
import edit from "assets/ic_edit.svg";
import trash from "assets/ic_trash.svg";
import duplicate from "assets/duplicate.svg";
import { ListItem } from "app/containers/types";

export const TableHeaderDefinition = {
  ORGANIZATION_ID: {
    id: "_id",
    label: "ORGANIZATION_ID",
    format: (value) => value,
    maxWidth: 130,
    minWidth: 130,
    sortable: false,
  },
  ORGANIZATION_NAME: {
    id: "name",
    label: "ORGANIZATION_NAME",
    format: (value) => value,
    maxWidth: 250,
    minWidth: 250,
    sortable: true,
  },
  CONTACT_NAME: {
    id: "contactName",
    label: "CONTACT_NAME",
    format: (value) => value,
    maxWidth: 200,
    minWidth: 200,
    sortable: true,
  },
  ADDRESS: {
    id: "address",
    label: "ADDRESS",
    format: (value) => value,
    maxWidth: 300,
    minWidth: 300,
    sortable: true,
  },
  TAX_NUMBER: {
    id: "taxNumber",
    label: "TAX_NUMBER",
    format: (value) => value,
    maxWidth: 150,
    minWidth: 150,
    sortable: true,
  },
  CREATED_DATE: {
    id: "createdAt",
    label: "CREATED_DATE",
    format: (value) => value,
    maxWidth: 160,
    minWidth: 160,
    sortable: true,
  },
  EDITED_DATE: {
    id: "updatedAt",
    label: "EDITED_DATE",
    format: (value) => value,
    maxWidth: 160,
    minWidth: 160,
    sortable: true,
  },
};

export const TableHeaders: TableHeaderColumnType[] = Object.values(
  TableHeaderDefinition
);

  export const MenuOptions: ListItem[] = [
    
    {
      id: "1",
      name: "EDIT",
      onClick: () => console.log("Download Folder"),
      icon: <img src={edit} alt="folder" />,
    },
    {
      id: "2",
      name: "ENABLE",
      onClick: () => console.log("Download File"),
      icon: <img src={duplicate} alt="file" />,
      isCheckBox:true,
    },
    {
      id: "3",
      name: "DELETE",
      onClick: () => console.log("Download Folder"),
      icon: <img src={trash} alt="controller" />,
    },
  ];
